import { createElement, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

import { reloadApplication, setSessionStorage } from "../../utils";
import { ButtonContained } from "./button";
import { ResponseMessages } from "../../constants/tostmsg";
import { ButtonVerifyStyle } from "../components/style";

let isReloadModalOpen = false;

export async function showReloadRequiredModal(
  status: number,
  message: string,
  header: string,
) {
  if (isReloadModalOpen) return;

  const containerId = "app-version-conflict-modal";
  let container = document.getElementById(containerId);

  if (!container) {
    container = document.createElement("div");
    container.id = containerId;
    document.body.appendChild(container);
  }

  const root = createRoot(container);

  const Modal = () => {
    const [open, setOpen] = useState<boolean>(true);

    useEffect(() => {
      isReloadModalOpen = true;
      return () => {
        isReloadModalOpen = false;
      };
    }, []);

    const handleOk = () => {
      setOpen(false);
      root.unmount();
      isReloadModalOpen = false;

      if (status === 401) {
        setSessionStorage("samlToken", null);

        window.location.replace("/");
        return;
      }

      reloadApplication();
    };

    useEffect(() => {
      if (status) {
        setOpen(true);
      }
      // eslint-disable-next-line
    }, [status]);

    return (
      <Dialog
        open={open}
        disableEscapeKeyDown
        onClose={(_event, reason) => {
          if (reason === "backdropClick") return;
        }}
      >
        <DialogTitle>{ResponseMessages(header)}</DialogTitle>
        <DialogContent>
          <DialogContentText>{ResponseMessages(message)}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonContained
            id="btnSubmit"
            onClick={() => handleOk()}
            label="Ok"
            disabled={false}
            style={ButtonVerifyStyle}
          />
        </DialogActions>
      </Dialog>
    );
  };

  root.render(createElement(Modal));
}